import Button from "../button/Button.jsx";

/**
 * Consistent table row actions (icons + accessible labels).
 * variant: outline-secondary | outline-primary | outline-success | outline-danger
 */
export function RowActionButton({
  label,
  iconClass,
  onClick,
  variant = "outline-secondary",
  disabled = false,
  className = "",
}) {
  return (
    <Button
      type="button"
      className={`btn btn-${variant} btn-sm ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      title={label}
    >
      <i className={iconClass} aria-hidden="true" />
    </Button>
  );
}

export function RowActions({ children, className = "" }) {
  return (
    <div className={`d-flex justify-content-center gap-2 flex-wrap ${className}`.trim()}>
      {children}
    </div>
  );
}

export const RowActionIcons = {
  view: "fa-regular fa-eye",
  edit: "fa-regular fa-pen-to-square",
  publish: "fa-solid fa-cloud-arrow-up",
  unpublish: "fa-solid fa-cloud-arrow-down",
  delete: "fa-regular fa-trash-can",
  crown: "fa-solid fa-crown",
  star: "fa-solid fa-star",
  userActivate: "fa-solid fa-user-check",
  userDeactivate: "fa-solid fa-user-slash",
  userEdit: "fa-solid fa-user-pen",
  password: "fa-solid fa-key",
};
